import api from 'js/api'
export const requestPasswordReset = (email) =>
  api('POST', 'v2/accounts/request_password_reset', {
    email,
  }).then((res) => res.response)
